import { z } from "zod";
/** Alarm ve bildirim (Prompt 20, ADR 0020) — sabit listeler ve Türkçe etiketleri. */
export const ALARM_SEVERITIES = ["CRITICAL", "IMPORTANT", "INFO"];
export const alarmSeveritySchema = z.enum(ALARM_SEVERITIES);
export const ALARM_SEVERITY_LABELS = {
    CRITICAL: "Kritik",
    IMPORTANT: "Önemli",
    INFO: "Bilgi",
};
export const ALARM_STATUSES = ["OPEN", "ACKNOWLEDGED", "ASSIGNED", "RESOLVED"];
export const alarmStatusSchema = z.enum(ALARM_STATUSES);
export const ALARM_STATUS_LABELS = {
    OPEN: "Açık",
    ACKNOWLEDGED: "Görüldü",
    ASSIGNED: "Atandı",
    RESOLVED: "Çözüldü",
};
export const ALARM_ACTIONS = ["ACKNOWLEDGE", "ASSIGN", "RESOLVE", "REOPEN"];
export const alarmActionSchema = z.enum(ALARM_ACTIONS);
export const ALARM_CATEGORIES = [
    "FUEL",
    "DEVICE",
    "SHIFT",
    "FINANCE",
    "INVOICING",
    "ACCOUNTING",
    "COMPLIANCE",
    "SALES",
    "CUSTOMER",
    "STOCK",
    "PRIVACY",
];
export const alarmCategorySchema = z.enum(ALARM_CATEGORIES);
export const ALARM_CATEGORY_LABELS = {
    FUEL: "Akaryakıt",
    DEVICE: "Ajan ve cihazlar",
    SHIFT: "Vardiya ve kasa",
    FINANCE: "Finans",
    INVOICING: "Fatura ve e-belge",
    ACCOUNTING: "Muhasebe",
    COMPLIANCE: "Belge ve lisans",
    SALES: "Satış",
    CUSTOMER: "Müşteri, sadakat ve filo",
    STOCK: "Stok",
    PRIVACY: "KVKK",
};
/** Zaman çizelgesi olay türleri (`alarm_events`, append-only). */
export const ALARM_EVENT_KINDS = [
    "RAISED",
    "REPEATED",
    "SEVERITY_RAISED",
    "ACKNOWLEDGED",
    "ASSIGNED",
    "NOTE",
    "ESCALATED",
    "NOTIFIED",
    "RESOLVED",
    "AUTO_RESOLVED",
    "REOPENED",
];
export const alarmEventKindSchema = z.enum(ALARM_EVENT_KINDS);
export const ALARM_EVENT_KIND_LABELS = {
    RAISED: "Oluştu",
    REPEATED: "Yinelendi",
    SEVERITY_RAISED: "Önemi yükseldi",
    ACKNOWLEDGED: "Görüldü",
    ASSIGNED: "Atandı",
    NOTE: "Not",
    ESCALATED: "Yükseltildi",
    NOTIFIED: "Bildirildi",
    RESOLVED: "Çözüldü",
    AUTO_RESOLVED: "Kendiliğinden çözüldü",
    REOPENED: "Yeniden açıldı",
};
export const NOTIFICATION_CHANNELS = ["IN_APP", "EMAIL", "SMS", "PUSH"];
export const notificationChannelSchema = z.enum(NOTIFICATION_CHANNELS);
export const NOTIFICATION_CHANNEL_LABELS = {
    IN_APP: "Uygulama içi",
    EMAIL: "E-posta",
    SMS: "SMS",
    PUSH: "Mobil bildirim",
};
export const NOTIFICATION_KINDS = ["ALARM", "ALARM_GROUP", "DIGEST_DAILY", "DIGEST_WEEKLY", "TEST"];
export const notificationKindSchema = z.enum(NOTIFICATION_KINDS);
export const NOTIFICATION_DELIVERY_STATUSES = ["PENDING", "SENT", "FAILED", "SKIPPED"];
export const notificationDeliveryStatusSchema = z.enum(NOTIFICATION_DELIVERY_STATUSES);
export const NOTIFICATION_DELIVERY_STATUS_LABELS = {
    PENDING: "Bekliyor",
    SENT: "Gönderildi",
    FAILED: "Başarısız",
    SKIPPED: "Atlandı",
};
/** Teslimin atlanma nedeni (`SKIPPED`). */
export const NOTIFICATION_SKIP_REASONS = [
    "PREFERENCE_OFF",
    "QUIET_HOURS",
    "BELOW_MIN_SEVERITY",
    "NO_ADDRESS",
    "CHANNEL_DISABLED",
];
export const NOTIFICATION_SKIP_REASON_LABELS = {
    PREFERENCE_OFF: "Tercih kapalı",
    QUIET_HOURS: "Sessiz saat",
    BELOW_MIN_SEVERITY: "Önem eşiğinin altında",
    NO_ADDRESS: "Adres yok (e-posta / telefon / cihaz)",
    CHANNEL_DISABLED: "Kanal kapalı",
};
export const PUSH_PLATFORMS = ["IOS", "ANDROID"];
export const pushPlatformSchema = z.enum(PUSH_PLATFORMS);
//# sourceMappingURL=enums.js.map